import { Link } from 'react-router';
import { pasticceria } from '@/data/creazioni';
import { Logo } from './Logo';

export function Footer() {
  const year = '2026';
  return (
    <footer className="relative mt-px bg-sage-deep text-cream">
      <div className="u-container py-20">
        <div className="mb-14 border-b border-white/15 pb-12">
          <Logo className="h-14 md:h-20" light />
        </div>

        <div className="grid gap-x-16 gap-y-12 md:grid-cols-[1.5fr_1fr_1fr]">
          <p className="max-w-sm text-lg leading-relaxed text-cream/80">
            Pasticceria artigianale e cake design a {pasticceria.citta}. Torte personalizzate,
            cupcakes e dolci su ordinazione per ogni occasione.
          </p>

          <nav className="flex flex-col gap-4 text-lg">
            <p className="eyebrow mb-3 text-cream/50">Esplora</p>
            <Link to="/" className="link-line w-fit">Home</Link>
            <Link to="/#creazioni" className="link-line w-fit">Creazioni</Link>
            <Link to="/ordina" className="link-line w-fit">Ordina una torta</Link>
          </nav>

          <div className="flex flex-col gap-4 text-lg">
            <p className="eyebrow mb-3 text-cream/50">Contatti</p>
            <a href={pasticceria.whatsapp} target="_blank" rel="noopener noreferrer" className="link-line w-fit">
              WhatsApp
            </a>
            <a href={pasticceria.instagram} target="_blank" rel="noopener noreferrer" className="link-line w-fit">
              Instagram
            </a>
            <p className="mt-2 text-base text-cream/60">{pasticceria.indirizzo}</p>
          </div>
        </div>
      </div>

      <div className="border-t border-white/15">
        <div className="u-container flex flex-col gap-3 py-8 text-sm text-cream/55 md:flex-row md:items-center md:justify-between">
          <p>© {year} Watermelon Studio</p>
          <p>
            Sito di{' '}
            <a href="https://watermelon-studio.it" target="_blank" rel="noopener noreferrer" className="link-line text-cream/80">
              Watermelon
            </a>
          </p>
          <Link to="/privacy" className="link-line">Privacy</Link>
        </div>
      </div>
    </footer>
  );
}
